module.exports = __webpack_public_path__ + "media/application/images/2023/hug_1.1.3-048906a6a695aa1615befd7dfa3366f5.png";